"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends6 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _overrides = require("../../../utils/overrides");

var _FieldControl = _interopRequireDefault(require("./FieldControl"));

var _Section = _interopRequireDefault(require("../Section"));

function Form(_ref) {
  var overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      labelMode = _ref.labelMode,
      isFullWidth = _ref.isFullWidth,
      isReadOnly = _ref.isReadOnly,
      schema = _ref.schema,
      onSubmit = _ref.onSubmit,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      values = _ref.values,
      errors = _ref.errors,
      customFields = _ref.customFields,
      useNativeForm = _ref.useNativeForm,
      isBulk = _ref.isBulk,
      bulkEditLabel = _ref.bulkEditLabel,
      bulkCancelLabel = _ref.bulkCancelLabel,
      onBulkEdit = _ref.onBulkEdit,
      onBulkCancel = _ref.onBulkCancel,
      props = (0, _objectWithoutProperties2.default)(_ref, ["overrides", "className", "labelMode", "isFullWidth", "isReadOnly", "schema", "onSubmit", "onChange", "onFocus", "onBlur", "values", "errors", "customFields", "useNativeForm", "isBulk", "bulkEditLabel", "bulkCancelLabel", "onBulkEdit", "onBulkCancel"]);
  // Overrides
  var override = (0, _overrides.getOverrides)(overridesProp, Form.overrides);
  var onChangeField = (0, _react.useCallback)(function (value, field) {
    var newValues = (0, _extends6.default)({}, values, (0, _defineProperty2.default)({}, field.name, value));

    if (field.type === 'inputGroup') {
      newValues = (0, _extends6.default)({}, values, value);
    }

    onChange && onChange(newValues, field, value);
  }, [values, onChange]);
  var onFocusField = (0, _react.useCallback)(function (value, field) {
    onFocus && onFocus((0, _extends6.default)({}, values, (0, _defineProperty2.default)({}, field.name, value)), field, value);
  }, [onFocus, values]);
  var onBlurField = (0, _react.useCallback)(function (value, field) {
    onBlur && onBlur((0, _extends6.default)({}, values, (0, _defineProperty2.default)({}, field.name, value)), field, value);
  }, [onBlur, values]);
  var onEnterField = (0, _react.useCallback)(function (value, field) {
    onSubmit && onSubmit((0, _extends6.default)({}, values, (0, _defineProperty2.default)({}, field.name, value)), field, value);
  }, [onSubmit, values]);
  var content = schema.map(function (section, index) {
    return /*#__PURE__*/_react.default.createElement(_Section.default, (0, _extends6.default)({
      key: index,
      title: section.title,
      className: section.className,
      isExpandable: section.isExpandable
    }, override.Section), section.fields.map(function (field) {
      var value = values && values[field.name] ? values[field.name] : undefined;

      if (field.type === 'inputGroup') {
        value = values;
      }

      return /*#__PURE__*/_react.default.createElement(_FieldControl.default, {
        key: field.name,
        labelMode: field.labelMode || labelMode,
        isFullWidth: field.isFullWidth || isFullWidth,
        isReadOnly: isReadOnly || field.isReadOnly,
        field: field,
        value: value,
        error: errors[field.name],
        onEnter: onEnterField,
        onChange: onChangeField,
        onFocus: onFocusField,
        onBlur: onBlurField,
        className: field.className,
        customFields: customFields,
        isBulk: isBulk,
        bulkEditLabel: bulkEditLabel,
        bulkCancelLabel: bulkCancelLabel,
        onBulkEdit: onBulkEdit,
        onBulkCancel: onBulkCancel,
        overrides: overridesProp
      });
    }));
  });

  var withForm = function withForm(children) {
    return /*#__PURE__*/_react.default.createElement("form", (0, _extends6.default)({
      className: classNameProp,
      action: "",
      autoComplete: "off"
    }, override.root), children);
  };

  var withDiv = function withDiv(children) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends6.default)({
      className: classNameProp
    }, override.root), children);
  };

  if (useNativeForm) return withForm(content);
  return withDiv(content);
}

Form.overrides = ['root', 'Section'];
Form.defaultProps = {
  labelMode: 'horizontal',
  isFullWidth: false,
  errors: {},
  values: {},
  schema: [],
  override: {},
  useNativeForm: false
};
process.env.NODE_ENV !== "production" ? Form.propTypes = {
  /** Native form class */
  className: _propTypes.default.string,
  labelMode: _propTypes.default.string,
  isFullWidth: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool,
  values: _propTypes.default.object,
  errors: _propTypes.default.object,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  customFields: _propTypes.default.object,
  useNativeForm: _propTypes.default.bool,
  schema: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    className: _propTypes.default.string,
    isExpandable: _propTypes.default.bool,
    fields: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      labelMode: _propTypes.default.string,
      isFullWidth: _propTypes.default.bool,
      name: _propTypes.default.string,
      type: _propTypes.default.string,
      placeholder: _propTypes.default.string,
      hint: _propTypes.default.string,
      isRequired: _propTypes.default.bool,
      isReadOnly: _propTypes.default.bool,
      attrs: _propTypes.default.object,
      className: _propTypes.default.string
    }))
  })).isRequired
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Form);

exports.default = _default;